var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"head"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/images/index/logo.png"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"menu",attrs:{"src":require("../assets/images/index/菜单栏.png"),"alt":""},on:{"click":_vm.menu}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d032a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = null
// module chunks = 